import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'components.Analytics.UsersQuantity.title',
    defaultMessage: 'Total de usuarios registrados en el evento'
  }
});
